/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'auth-attribute-match';
const prefix = `${moduleName}.${componentName}`;

export const attributeNameLabel = `${prefix}.attributeNameLabel`;
export const attributeNamePlaceholder = `${prefix}.attributeNamePlaceholder`;

export const ENGLISH = {
    [attributeNameLabel]: 'Attribute Name',
    [attributeNamePlaceholder]: 'Enter Attribute Name',
};
